__turbopack_context__.v({
  "root": "ExpertSection-module__lLzNjW__root",
});
